import { Form, Input, Select } from "antd";

export default ({ serviceTypes, hospitals, serviceStats }) => {
  return [
    {
      label: "Нэр",
      name: "name",
      rules: [{ required: true, message: "Нэр оруулна уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
      },
    },
    {
      label: "Үнэ",
      name: "price",
      type: "number",
      rules: [{ required: true, message: "Үнэ оруулна уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
      },
    },
    {
      label: "Эмнэлэг",
      name: "hospitalId",
      type: "select",

      rules: [{ required: true, message: "Төхөөрөмж сонгоно уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
        options: hospitals,
      },
    },
    {
      label: "Төхөөрөмж",
      name: "servicetypeid",
      type: "select",
      rules: [{ required: true, message: "Төхөөрөмж сонгоно уу!" }],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
        options: serviceTypes,
      },
    },

    {
      label: "Үзүүлэлт",
      name: "servicestatsid",
      type: "select",

      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
        options: serviceStats,
      },
    },
    {
      label: "Дэлгэрэнгүй мэдээлэл",
      name: "descr",
      type: "textarea",
      // rules: [{required: true, message: 'Төрсөн огноо сонгоно уу!'}],
      className: "col-span-12 md:col-span-6 mb-0",
      inputProps: {
        className: "w-full",
      },
    },
  ];
};
